export default __webpack_public_path__ + "static/B0106-610557d25dace6dbfc323c9f4118fc6a.png";